const translations = {
  "en": {
    "Analysis is great, but without action, it's just cope. Take control of your portfolio now and execute trades directly via our integrated exchanges.": "Analysis is great, but without action, it's just cope. Take control of your portfolio now and execute trades directly via our integrated exchanges.",
    "Coming soon": "Coming soon",
    "Recommended exchanges: Binance.": "Recommended exchanges: Binance.",
    "Turn This Analysis Into A Trade Now": "Turn This Analysis Into A Trade Now"
  },
  "zh-tw": {
    "Analysis is great, but without action, it's just cope. Take control of your portfolio now and execute trades directly via our integrated exchanges.": "分析固然重要，但沒有行動，一切都是空談。立即掌控你的投資組合，並透過我們整合的交易所直接執行交易。",
    "Coming soon": "即將推出",
    "Recommended exchanges: Binance.": "推薦交易所：Binance。",
    "Turn This Analysis Into A Trade Now": "立即將此分析轉化為交易"
  }
};

export default translations;
